"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _redux = require("redux");

var _reactRedux = require("react-redux");

var _semanticUiReact = require("semantic-ui-react");

var _reactRouterDom = require("react-router-dom");

var _actions = require("../actions");

var _ForgotPasswordForm = _interopRequireDefault(require("../components/ForgotPasswordForm"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ForgotPassword = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ForgotPassword, _React$Component);

  function ForgotPassword(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "handleSubmit", function (email) {
      var _this$props = _this.props,
          forgotPassword = _this$props.forgotPassword,
          productId = _this$props.productId;
      forgotPassword(email, productId).then(function (success) {
        return success === true ? _this.setState({
          resetPasswordRequested: true
        }) : false;
      });
    });

    _this.state = {
      resetPasswordRequested: false // authToken: getAuthToken()

    };
    return _this;
  }

  var _proto = ForgotPassword.prototype;

  _proto.render = function render() {
    /* TODO: Error handling, once the API has been implemented */
    var _this$props2 = this.props,
        isFetching = _this$props2.isFetching,
        error = _this$props2.error;
    var resetPasswordRequested = this.state.resetPasswordRequested;
    return /*#__PURE__*/React.createElement("div", {
      className: "page--multifaceted-bg-grey"
    }, /*#__PURE__*/React.createElement(_semanticUiReact.Container, {
      className: "page-container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "login-form"
    }, /*#__PURE__*/React.createElement(_semanticUiReact.Grid, {
      stackable: true,
      centered: true
    }, /*#__PURE__*/React.createElement(_semanticUiReact.Grid.Column, {
      width: 6
    }, /*#__PURE__*/React.createElement("div", {
      className: "callout"
    }, /*#__PURE__*/React.createElement("h2", null, "Forgot Password"), /*#__PURE__*/React.createElement(_semanticUiReact.Grid, {
      stackable: true,
      centered: true
    }, /*#__PURE__*/React.createElement(_semanticUiReact.Grid.Column, {
      width: 10
    }, error && /*#__PURE__*/React.createElement(_semanticUiReact.Message, {
      warning: true,
      icon: "warning",
      content: error
    }), !resetPasswordRequested ?
    /*#__PURE__*/

    /* $FlowFixMe */
    React.createElement(_ForgotPasswordForm["default"], {
      handleSubmit: this.handleSubmit,
      isFetching: isFetching,
      error: error
    }) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, "If that account exists and you haven't reached your forgotten password limit, we have sent you an email with instructions on how to reset your password. Please check your email inbox."), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(_reactRouterDom.NavLink, {
      to: "/login"
    }, "Back to Login")))))))))));
  };

  return ForgotPassword;
}(React.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    isFetching: state.auth.user.isFetching,
    error: state.auth.error
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    forgotPassword: _actions.forgotPassword
  }, dispatch);
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ForgotPassword);

exports["default"] = _default;